import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface HmsLocationParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
}

export interface HmsLocation {
    locationId?: number;
    locationName?: string;
    Doorno?: string;
    Address1?: string;
    Address2?: string;
    City?: string;
    District?: string;
    State?: string;
    Country?: string;
    Landmark?: string;
    Pincode?: string;
    Mobile?: string;
    GSTN?: string;
    Email?: string;
    ReportLine1?: string;
    ReportLine2?: string;
    ReportLine3?: string;
    ReportLine4?: string;
    ReportLine5?: string;
    ReportLogo?: string;
    ReportMessage?: string;
    reportLogo?:string,
    printAddressSelected?: string;
    TenantId?: string;
    BranchId?: string;
    districtId?: string;
    stateId?: string;
    countryId?: string;
    parameters?: HmsLocationParameter[];
    links?: any;
}

export abstract class HmsLocationData {
    abstract list(url: string): Observable<HmsLocation[]>;
    abstract create(url: string, data: HmsLocation): Observable<any>;
    abstract update(url: string, data: HmsLocation): Observable<any>;
    abstract delete(url: string): Observable<any>;
}